(function () {
    'use strict';
    angular
    .module("app")
    .controller('ServicesController', ServicesController);

    ServicesController.$inject = ['$scope', '$rootScope', 'ModelController', 'Service'];

    function ServicesController($scope, $rootScope, ModelController, Service) {
        $scope.searchEnabled = $(window).outerHeight() >= 720;

        var options = {propertyName: "id", reverse: true, quantity: 50};
        var defaultModel = {
            name: ""
        };
        var settings = {
            defaultModel: defaultModel
        }

        $scope.Services = new ModelController(Service, options, settings);
        $rootScope.searchBox.link($scope.Services.list);
    }
})();
